import _ from 'lodash'
import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

import { useAppDispatch, useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import { getEstablishment, selectEstablishmentById } from '@/redux/reducers/establishment.reducer'
import {
  createEstablishmentChatChannel,
  createStaffChatDirectMessage,
  selectChatChannelByEstablishment,
  selectChatDirectMessageByStaff,
} from '@/redux/reducers/rocket-chat.reducer'

import { getEnv } from '@/utils/helpers'
import { useRocketChatIframe } from '@/hooks/useRocketChatIframe'

export function RocketChatPage() {
  const dispatch = useAppDispatch()
  const [searchParams] = useSearchParams()

  const authUser = useAppSelector(selectAuthUser)
  const establishment = useAppSelector((state) => {
    if (!authUser || _.isUndefined(authUser.establishment)) return undefined

    if (typeof authUser.establishment !== 'string') return authUser.establishment

    return selectEstablishmentById(state, authUser.establishment)
  })
  const establishmentChatChannelIframeUrl = useAppSelector((state) => (establishment ? selectChatChannelByEstablishment(state, establishment._id) : undefined))
  const staffChatDirectMessageIframeUrl = useAppSelector((state) =>
    searchParams.get('staff') ? selectChatDirectMessageByStaff(state, searchParams.get('staff')!) : undefined
  )

  const { isReady, ref: iframeRef } = useRocketChatIframe()

  useEffect(() => {
    if (!isReady) return

    const roomType = searchParams.get('roomType')
    const staffId = searchParams.get('staff')
    const username = searchParams.get('username')

    if (roomType === 'd' && !!staffId && !!username) {
      dispatch(createStaffChatDirectMessage(staffId, username, false))
    }
  }, [dispatch, isReady, searchParams])

  useEffect(() => {
    if (!authUser) return

    if (_.isUndefined(authUser.establishment) || typeof authUser.establishment !== 'string') return

    dispatch(getEstablishment(authUser.establishment))
  }, [dispatch, authUser])

  useEffect(() => {
    if (!establishment || !isReady || searchParams.toString() !== '') return

    dispatch(createEstablishmentChatChannel(`Establishment_${establishment.name}`, establishment._id, false))
  }, [dispatch, establishment, isReady, searchParams])

  useEffect(() => {
    if (!isReady) return

    if (searchParams.toString() === '' && !!establishmentChatChannelIframeUrl) {
      const { origin, pathname } = new URL(establishmentChatChannelIframeUrl)
      iframeRef.current?.contentWindow?.postMessage(
        {
          externalCommand: 'go',
          path: pathname,
        },
        origin
      )
      return
    }

    const roomType = searchParams.get('roomType')
    const staffId = searchParams.get('staff')
    const username = searchParams.get('username')

    if (roomType === 'd' && !!staffId && !!username && !!staffChatDirectMessageIframeUrl) {
      const { origin, pathname } = new URL(staffChatDirectMessageIframeUrl)
      iframeRef.current?.contentWindow?.postMessage(
        {
          externalCommand: 'go',
          path: pathname,
        },
        origin
      )
    }
  }, [iframeRef, isReady, establishmentChatChannelIframeUrl, staffChatDirectMessageIframeUrl, searchParams])

  return (
    <iframe ref={iframeRef} title="rocket-chat-page" width="100%" height="100%" src={getEnv('VITE_ROCKETCHAT_URL')} style={{ border: 'none' }}></iframe>
  )
}

export default RocketChatPage
